import {PrinterIcon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {PrintSiarDialog} from '@/features/projects/components/print-siar-dialog/PrintSiarDialog'
import {ProjectIndex} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'

export const ProjectOptionPrintSiarMenuItem = ({project}: {project: ProjectIndex}) => {
    const {t} = useTranslation()

    if (!project.status || !project.progressStatus) {
        return null
    }

    return (
        <PrintSiarDialog
            projectId={project.id}
            status={project.status}
            progressStatus={project.progressStatus}
            projectCode={project.code}
            customTrigger={({onClick, isDisabled}) => (
                <MenuItem
                    disabled={isDisabled}
                    onClick={e => {
                        e.preventDefault()
                        onClick(e)
                    }}
                >
                    <PrinterIcon />
                    {t('projects:print_siar')}
                </MenuItem>
            )}
        />
    )
}
